module.exports = __webpack_public_path__ + "inactive-analysis.png?165f0d0a874f32ebbdbb8f9b65461722";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/inactive-analysis.png
// module id = 964
// module chunks = 2